<template>
	<div class="user-container">
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<div class="search-area">
					<el-form :model="userReq" label-width="70px" inline size="small">
						<el-form-item label="昵称">
							<el-input :clearable = true placeholder="请输入昵称" v-model="userReq.searchValue" @change="getUserList()" style="width: 300px;"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="addUserInit()">+ 添加用户</el-button>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="getUserList()">查询</el-button>
						</el-form-item>
					</el-form>
				</div>
			<!-- 用户列表区 -->
			<el-table :data="userList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index"></el-table-column>
				<el-table-column label="用户名" prop="username"></el-table-column>
				<el-table-column label="角色名称" prop="roleNames"></el-table-column>
				<el-table-column label="昵称" prop="nickName"></el-table-column>
				<el-table-column label="修改时间" prop="updateTime"></el-table-column>
				<el-table-column label="创建时间" prop="createTime"></el-table-column>
				<el-table-column label="状态">
					<template slot-scope="scope">
						<el-switch v-model="scope.row.state" @change="userStateChanged(scope.row)"></el-switch>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120px">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" size="mini"
							@click="editUser(scope.row.userId)">编辑</el-button>
						<!-- <el-button type="danger" icon="el-icon-delete" size="mini"
							@click="deleteUser(scope.row.userId)">删除
						</el-button> -->
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页区域 -->
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="userReq.page" :page-sizes="[8, 15, 25, 50, 100]" :page-size="userReq.limit"
				layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
			<!-- 添加用户 -->
			<el-dialog title="添加用户" :visible.sync="addUserDialogVisible" width="800px">
				<!-- form表单 -->
				<el-form :model="addUserInfoReq" status-icon :rules="addUserRules" ref="userInfo" label-width="100px"
					class="demo-ruleForm">
					<el-form-item label="用户名" prop="username">
						<el-input type="text" v-model="addUserInfoReq.username" autocomplete="off" size="small" :clearable=true>
						</el-input>
					</el-form-item>
					<el-form-item label="角色:" prop="roleIds">
						<template>
							<el-select v-model="addUserInfoReq.roleIds" placeholder="请选择" :multiple=true
								:filterable=true size="small">
								<el-option v-for="item in roles" :key="item.id" :label="item.roleName"
									:value="item.roleId">
								</el-option>
							</el-select>
						</template>
					</el-form-item>
					<el-form-item label="昵称" prop="nickName">
						<el-input v-model.number="addUserInfoReq.nickName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="生日" prop="birthday">
						<el-date-picker v-model="addUserInfoReq.birthday" type="datetime" :clearable=true
							placeholder="选择日期" size="small">
						</el-date-picker>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addUserDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="addUser()">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 修改用户 -->
			<el-dialog title="修改用户" :visible.sync="updateUserDialogVisible" width="800px">
				<el-form :model="updateUserInfoReq" status-icon :rules="updateUserRules" ref="updateUserInfoReq"
					label-width="100px" class="demo-ruleForm">
					<el-form-item label="用户名" prop="username">
						<el-input type="text" v-model="updateUserInfoReq.username" autocomplete="off" size="small" :clearable=true>
						</el-input>
					</el-form-item>
					<el-form-item label="角色:" prop="userRoles">
						<template>
							<el-select v-model="updateUserInfoReq.roleIds" placeholder="请选择" :multiple=true
								:filterable=true size="small">
								<el-option v-for="item in roles" :key="item.id" :label="item.roleName"
									:value="item.roleId">
								</el-option>
							</el-select>
						</template>
					</el-form-item>
					<el-form-item label="昵称" prop="nickName">
						<el-input v-model.number="updateUserInfoReq.nickName" size="small" :clearable=true></el-input>
					</el-form-item>
					<el-form-item label="生日" prop="birthday">
						<el-date-picker v-model="updateUserInfoReq.birthday" type="datetime" :clearable=true
							placeholder="选择日期" size="small">
						</el-date-picker>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateUserDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateUser()">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
export default {
	data() {
		return {
			userReq: {
				//当前页数
				page: 1,
				//当前每页多少条
				limit: 8,
				searchValue: '',
			},
			userList: [],
			total: 0,
			//控制添加用户信息对话框显示与隐藏
			addUserDialogVisible: false,
			updateUserDialogVisible: false,
			addUserInfoReq: {
				username: '',
				nickName: '',
				birthday: '',
				roleIds: []
			},
			updateUserInfoReq: {
				username: '',
				nickName: '',
				birthday: '',
				roleIds: []
			},
			roles: [],
			addUserRules: {
				//验证用户名是否合法
				username: [{
					required: true,
					message: '请输入用户名',
					trigger: 'blur',
				},
				{
					min: 3,
					max: 16,
					message: '长度在 3 到 16 个字符',
					trigger: 'blur',
				}
				],
			},
			updateUserRules: {
				//验证用户名是否合法
				username: [{
					required: true,
					message: '请输入用户名',
					trigger: 'blur',
				},
				{
					min: 3,
					max: 16,
					message: '长度在 3 到 16 个字符',
					trigger: 'blur',
				}
				],
			}
		}
	},
	created() {
		this.getUserList()
	},
	methods: {
		async getUserList() {
			const {
				data: res
			} = await this.$http.post(
				'/system/user/list',
				this.userReq)
			if (res.code != 0) return this.$message.error(res.msg)
			this.userList = res.data
			this.total = res.count
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.userReq.limit = pageSize
			this.getUserList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.userReq.page = pageNum
			this.getUserList()
		},
		userStateChanged(userInfo) {
			this.$http.post('/system/user/updateState', {
				userId: userInfo.userId,
				state: userInfo.state,
			}).then((res) => {
					this.$message.success(res.data.msg)
				})
		},
		getRoles(){
			this.$http.get('/system/role/listAll').then((res) => {
				if (res.data.code == 200) {
					this.roles = res.data.data;
					return;
				}
				this.$message.error(res.data.msg)
			})
		},
		addUserInit() {
			this.addUserInfoReq = {}
			this.getRoles()
			this.addUserDialogVisible = true
		},
		addUser() {
			this.$http.post('/system/user/add', this.addUserInfoReq).then((res) => {
				if (res.data.code == 200) {
					this.addUserDialogVisible = false
					this.getUserList()
					this.$message.success(res.data.msg)
				} else {
					this.$message.error(res.data.msg)
				}
			})
		},
		deleteUser(userId) {
			this.$confirm("确认删除该条数据吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('system/user/deleteById/' + userId).then(res => {
					if (res.data.code == 200) {
						this.getUserList()
						this.$message.success(res.data.msg)
					}
				})
			})
		},
		editUser(userId) {
			this.getRoles();
			this.$http.get('system/user/queryById/' + userId).then(res => {
				if (res.data.code == 200) {
					this.updateUserInfoReq.userId = res.data.data.userId
					this.updateUserInfoReq.username = res.data.data.username
					this.updateUserInfoReq.nickName = res.data.data.nickName
					this.updateUserInfoReq.birthday = res.data.data.birthday
					let roleIds = []
					for(let index in res.data.data.userRoles){
						roleIds.push(res.data.data.userRoles[index].roleId)
					}
					this.updateUserInfoReq.roleIds = roleIds
					this.updateUserDialogVisible = true
					return;
				}
				this.$message.error(res.data.msg)
			})
		},
		updateUser(){
			console.log("this.updateUserInfoReq ：",this.updateUserInfoReq)
			this.$http.post('system/user/update',this.updateUserInfoReq).then((res) => {
				if (res.data.code == 200) {
					this.updateUserDialogVisible = false
					this.getUserList()
					this.$message.success(res.data.msg)
				} else {
					this.$message.error(res.data.msg)
				}
			})
		}
	},
}
</script>

<style>
.user-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.box-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.search-area {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #EBEEF5;
}
</style>
